import { Directive, HostListener, Inject, Input } from '@angular/core';
import { getId, sameId } from '@cawita/core-front';
import { ActionSheetController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Partner, Profile, ProfileReport, Stay } from '../../../../../frontend-shared/src/lib/models';
import { GenericCrudService, getCrudName } from '../../../../../frontend-shared/src/lib/modules/crud';
import { AlertService } from '../../services/commons/alert.service';
import { LoggedProfileStore } from './logged-profile.store';

@Directive({
  selector: '[cwtProfileBlock]'
})
export class ProfileBlockDirective {

  @Input() profile: Profile;
  @Input() partner: Partner;

  constructor(
    private actionSheet: ActionSheetController,
    private alert: AlertService,
    private translate: TranslateService,
    private loggedProfileStore: LoggedProfileStore,
    @Inject(getCrudName(ProfileReport)) private profileReportCrud: GenericCrudService<ProfileReport>,
  ) { }

  @HostListener('click')
  async block() {
    const { profile: loggedProfile } = this.loggedProfileStore.getValue();
    const isBlocked = loggedProfile?.blockedProfiles?.some(p => sameId(p, this.profile));

    const actionSheet = await this.actionSheet.create({
      header: await this.translate.get('alert.block-or-report-user-header').toPromise(),
      buttons: [
        isBlocked ? { role: 'unblock', icon: 'lock-open-outline', text: await this.translate.get('action.unblock-user').toPromise() } : undefined,
        !isBlocked ? { role: 'block', icon: 'lock-closed-outline', text: await this.translate.get('action.block-user').toPromise() } : undefined,
        { role: 'report', icon: 'alert-circle-outline', text: await this.translate.get('action.report-user').toPromise() },
      ].filter(Boolean)
    });

    await actionSheet.present();

    const res = await actionSheet.onDidDismiss();

    if (res.role === 'block') this._block();
    if (res.role === 'unblock') this._unblock();
    if (res.role === 'report') this._report();

    // this.router.navigate(['/'], { replaceUrl: true });
  }

  private async _report() {
    const content = await this.alert.input({
      title: 'alert.report-user',
      message: 'alert.report-user-reason',
      type: 'text',
    });

    if (!content?.length) return;

    this.profileReportCrud.create({
      reported: getId(this.profile),
      partner: getId(this.partner),
      content: content
    }).subscribe();
  }

  private _block() {
    this.loggedProfileStore.block(this.profile).subscribe();
  }

  private _unblock() {
    this.loggedProfileStore.unblock(this.profile).subscribe();
  }
}
